module.exports = __webpack_public_path__ + "img/sb5.b97456c1.png";